import { NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class DevToolsDetectorService {
    constructor(ngZone) {
        this.ngZone = ngZone;
        this.devToolsOpened$ = new BehaviorSubject(false);
        if (typeof window !== 'undefined') {
            this.startDetection();
        }
    }
    // private startDetection() {
    //   this.ngZone.runOutsideAngular(() => {
    //     setInterval(() => {
    //       const opened = this.isDevToolsOpen() || this.isDevToolsMobileMode();
    //       this.ngZone.run(() => this.devToolsOpened$.next(opened));
    //     }, 1000);
    //   });
    // }
    startDetection() {
        const isMobile = /mobi|android|iphone|ipad/.test(navigator.userAgent.toLowerCase());
        if (isMobile)
            return; // Stop detection on mobile
        this.ngZone.runOutsideAngular(() => {
            setInterval(() => {
                const opened = this.isDevToolsOpen() || this.isDevToolsMobileMode();
                this.ngZone.run(() => this.devToolsOpened$.next(opened));
            }, 1000);
        });
    }
    isDevToolsOpen() {
        const threshold = 150;
        const widthDiff = window.outerWidth - window.innerWidth;
        const heightDiff = window.outerHeight - window.innerHeight;
        return widthDiff > threshold || heightDiff > threshold;
    }
    isDevToolsMobileMode() {
        const userAgent = navigator.userAgent.toLowerCase();
        const isMobileUA = /mobi|android|iphone|ipad/.test(userAgent);
        const isDesktopUA = !isMobileUA;
        const hasTouchPoints = navigator.maxTouchPoints > 1;
        const isEmulatedMobile = window.innerWidth < 500 && isDesktopUA && hasTouchPoints;
        const suspiciousRatio = Math.abs(window.devicePixelRatio - 1.0) > 0.3;
        return isEmulatedMobile && suspiciousRatio;
    }
}
DevToolsDetectorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DevToolsDetectorService_Factory() { return new DevToolsDetectorService(i0.ɵɵinject(i0.NgZone)); }, token: DevToolsDetectorService, providedIn: "root" });
